<div class="category-tree-child">
  @if (useNavigate) {
    <span
      class="category-tree-child__title" [attr.data-test]="'desc-' + category.name"
      [ngClass]="{'selected': isSelected(category)}"
      (click)="selectCategory(category)">
      {{ category.name }}
      @if (category.itemCount) {
        <span
          [attr.data-test]="'desc-categoryItemCount-' + category.nodeId"
          class="category-tree-child__count">({{ category.itemCount }})</span>
      }
    </span>
  } @else {
    <a
      [routerLink]="pageUrl(category)"
      [queryParams]="categoryUrl(category)"
      class="category-tree-child__title"
      [ngClass]="{'selected': isSelected(category)}"
      (click)="selectCategory(category)"
      [attr.data-test]="'category-' + category.name">
      {{ category.name }}
      @if (category.itemCount) {
        <span
          [attr.data-test]="'desc-categoryItemCount-' + category.nodeId"
          class="category-tree-child__count">({{ category.itemCount }})</span>
      }
    </a>
  }
</div>
